import dayjs from "dayjs";
/** Локали */
import "dayjs/locale/ru";
/** Плагины */
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekday from "dayjs/plugin/weekday";

export const initDayjs = (locale = "ru") => {
  /** https://day.js.org/docs/ru-RU/plugin/custom-parse-format для поддержки кастомных форматов (исправление Invalid Date) */
  dayjs.extend(customParseFormat);
  dayjs.extend(duration);
  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.extend(weekOfYear);
  dayjs.extend(weekday);

  dayjs.locale(locale);
};
